export default __webpack_public_path__ + "static/media/newLogo.93249cde.png";